import { BaseUrls } from '../api/Internal/URL';
import * as wicamApi from './wicamApi';
import { StorageKeys, wicamAccessToken, WicamAuthToken } from '../api/Internal/Api';
import { removeItem } from '../storage';

export * from './wicamApi';

export const api = new wicamApi.Api({
  baseURL: BaseUrls.WICAM_BASE,
});

api.instance.interceptors.request.use(
  async (config: any) => {
    const token = await WicamAuthToken.getToken();
    return {
      ...config,
      headers: {
        ...config.headers,
        ...(token && {
          Authorization: `Bearer ${token}`,
        }),
      },
    };
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      removeItem(StorageKeys.WICAM_ACCESS_TOKEN);
      return wicamAccessToken()
        .then(() => {
          return api.instance(originalRequest);
        })
        .catch((err) => {
          console.log('ERROR ', err);
        });
    }
    return Promise.reject(error);
  }
);
